import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

const WinnerSlider = () => {
  const winners = [
    {
      rank: 1,
      game: "Aviator",
      user: "*******618",
      amount: "101,545",
      icon: "https://images.6440949940.com/TCG_GAME_ICONS/SPB/EN/SPB002.png",
    },
    {
      rank: 2,
      game: "9 Coins™ Grand Gold Edition",
      user: "*******502",
      amount: "100,800",
      icon: "https://images.6440949940.com/TCG_GAME_ICONS/WD/EN/WD0160.png",
    },
    {
      rank: 3,
      game: "সুপার এস স্ক্র্যাচ",
      user: "*******147",
      amount: "100,000",
      icon: "https://images.6440949940.com/TCG_GAME_ICONS/JL/EN/JL0168.png",
    },
    {
      rank: 4,
      game: "Aviator",
      user: "*******339",
      amount: "96,300",
      icon: "https://images.6440949940.com/TCG_GAME_ICONS/SPB/EN/SPB002.png",
    },
     {
      rank: 5,
      game: "Crazy Time",
      user: "*******699",
      amount: "80,040",
      icon: "https://images.6440949940.com/TCG_GAME_ICONS/EG4/EN/EG4147.png",
    },
     {
      rank: 6,
      game: "Mega Wheel",
      user: "*******350",
      amount: "45,450",
      icon: "https://images.6440949940.com/TCG_GAME_ICONS/PP/EN/PP0179.png",
    },
     {
      rank:7,
      game: "Crazy Time",
      user: "*******183",
      amount: "40,020",
      icon: "https://images.6440949940.com/TCG_GAME_ICONS/EG4/EN/EG4147.png?t=1755764428310",
    },
  ];

  return (
    <div className="winner-content">
      <Swiper
  direction="vertical"
  loop={true}
  slidesPerView={5}           
  spaceBetween={0}
  speed={1500}                 
  autoplay={{ 
    delay: 0, 
    disableOnInteraction: false,
    // reverseDirection: true   // 👈 moves from bottom to top
  }}
  modules={[Autoplay]}
  className="winner-swiper"
  // style={{ height: "240px" }}
>
        {winners.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="winner-item">
              <div className="winner-rank">{item.rank}</div>
              <img className="game-icon" src={item.icon} alt={item.game} />
              <div className="game-info">
                <div className="winner-game">
                  <span>{item.game}</span>
                </div>
                <div className="winner-name">
                  <span>{item.user}</span>
                </div>
                <div className="winner-amount">
                  <span className="symbol">৳</span>
                  <span>{item.amount}</span>
                </div>
              </div>
              <div className="winner-btn">খেলুন</div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default WinnerSlider;